import { users_api_close_hint_url } from 'mk/urls/functions';
import {
    HINTS_CLOSE_HINT,
    HintsCloseHintAction,
    hintsCloseHintApi,
} from 'mk2/apps/users/containers/Hints/Hints.actions';
import { XHRAction } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import React from 'react';
import { all, call, put, takeEvery } from 'redux-saga/effects';

const logger = getLogger('users/Hints.sagas');

function* closeHint({ name, xhr }: HintsCloseHintAction & XHRAction) {
    yield put(hintsCloseHintApi.request(name));

    try {
        const response = yield call(
            () => xhr.post(users_api_close_hint_url(name)),
        );

        const normalizedResponse = normalize(response.body, {});

        yield put(hintsCloseHintApi.success(name, normalizedResponse));

    } catch (error) {
        yield put(hintsCloseHintApi.failure(name, error));
    }
}

export default function* root() {
    yield all([
        takeEvery(HINTS_CLOSE_HINT, closeHint),
    ]);
}
